import axios from 'axios';

const instance = axios.create({
  baseURL: '/',
  timeout: 20000,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

export default function userSignup(values) {
  const request = instance.post('/users.json', { user: values });

  return new Promise((res, rej) => {
    request
      .then(response => res(response))
      .catch(error => rej(error.response.data.errors));
  });
}

export function callCep(cep) {
  return axios.get(`https://viacep.com.br/ws/${cep}/json/`);
}
